
export default {
    actions:{
            //импорт счета из 1с
        import1C: function({dispatch,rootState}, arrayMain1c){
            let arrayLength =  arrayMain1c["Transactions"].length - 1
            let periodStart = new Date(arrayMain1c["Transactions"][0]['dataSort'])
            let periodEnd = new Date(arrayMain1c["Transactions"][arrayLength]['dataSort'])
            let periodData1CArr = {
                'periodStart': periodStart,
                'periodEnd': periodEnd
            }
            rootState.import1CStore = arrayMain1c
            rootState.periodData1CStore = periodData1CArr

            let num
            rootState.accountInfo.forEach((item, i) =>
            {
                if (item.Number == arrayMain1c.AccountNumber) num = i
            });

            dispatch('bitrixTrans', { load: 'import', num}, {root: true})
        },
    }
}